import { ComponentContainer, SectionSeparator } from '@styles/layout';
import { GenericComponent } from '@model/content';
import { TripTypes } from '@model/common';
import { useAsync } from 'react-use';
import { Category, ContentApi, ImageApi } from '@model/iceberg';
import { ToursApi } from '@model/iceberg/service/tours';
import { LinkListGroup, ResponseLevel } from '@components/common/link-list';

export const DestinationListContainer = ({ path, tripType }: GenericComponent) => {
  if (!path) return null;

  const tripTypeValue = tripType || TripTypes.ALL;

  const { value } = useAsync(async () => {
    const [continents, tripTypeTours] = await Promise.all([
      await new ContentApi().getGeography(),
      await new ToursApi().getTripTypeTours(tripTypeValue)
    ]);

    const responseLevel: ResponseLevel = tripTypeTours?.data[Object.keys(tripTypeTours?.data)[0]]?.path?.includes('/')
      ? ResponseLevel.COUNTRY
      : ResponseLevel.CONTINENT;

    const paths: Array<string> =
      responseLevel === ResponseLevel.COUNTRY
        ? Object.keys(tripTypeTours?.data).map((countryName: string) => tripTypeTours?.data[countryName]?.path)
        : continents.map((item: any) => item.path);

    const imageApi: ImageApi = new ImageApi();

    const listImages = await Promise.all(
      paths.map(async (path: string) => {
        const imageResponse = await imageApi.images({
          path: path,
          count: 1,
          category: Category.SCENERY
        });

        return {
          path: path,
          imageUrl: imageResponse.images[0]
        };
      })
    );

    return { tripTypeTours: tripTypeTours?.data || {}, listImages, responseLevel };
  }, [path]);

  if (!value) return null;

  return (
    <ComponentContainer>
      <LinkListGroup
        tripType={tripTypeValue}
        tripTypeTours={value.tripTypeTours}
        images={value.listImages}
        responseLevel={value.responseLevel}
        heading={'trip-type-landing__tour-destinations--title'}
      />
      <SectionSeparator />
    </ComponentContainer>
  );
};
